// Módulo Auth
// Exporta todo lo necesario para usar el módulo

// API
export { authApi } from './api';

// Types
export type { 
  Usuario,
  Empresa,
  SolicitarOtpRequest,
  SolicitarOtpResponse,
  VerificarOtpRequest,
  VerificarOtpResponse,
  RefreshTokenResponse,
  MeResponse,
  AuthState
} from './types';

// Store (re-export desde lib por compatibilidad)
export { 
  useAuthStore,
  useToken,
  useUser,
  useEmpresa,
  useIsAuthenticated,
  useTenant
} from '@/lib/auth-store';

// Components (cuando existan)
// export { LoginForm } from './components/login-form';
// export { OtpInput } from './components/otp-input';
